import {
  ApiConfig,
  ContactFormStep,
  EmployeeSelectionStep,
  ExternalLandingPageStep,
  FeedbackStep,
  GoodbyeStep,
  OnlineReviewStep,
  MessageStep,
  QuestionStep,
  RatingStep,
  RatingNPSStep,
  WordOfMouthChannelsStep,
  WordOfMouthStep,
  ContactFormExternalStep,
  OnlineReviewStepAction
} from './steps';
import { AiFeedbackStep } from './steps/ai-feedback-step.interface';

export type Step =
  | ContactFormStep
  | FeedbackStep
  | AiFeedbackStep
  | RatingStep
  | RatingNPSStep
  | WordOfMouthStep
  | WordOfMouthChannelsStep
  | OnlineReviewStep
  | GoodbyeStep
  | MessageStep
  | QuestionStep
  | ExternalLandingPageStep
  | EmployeeSelectionStep
  | ContactFormExternalStep;

export enum StepType {
  MESSAGE = 'MESSAGE',
  QUESTION = 'QUESTION',
  RATING = 'RATING',
  RATING_NPS = 'RATING_NPS',
  FEEDBACK = 'FEEDBACK',
  AI_FEEDBACK = 'AI_FEEDBACK',
  WORD_OF_MOUTH = 'WORD_OF_MOUTH',
  WORD_OF_MOUTH_CHANNELS = 'WORD_OF_MOUTH_CHANNELS',
  ONLINE_REVIEW = 'ONLINE_REVIEW',
  CONTACT_FORM = 'CONTACT_FORM',
  CONTACT_FORM_EXTERNAL = 'CONTACT_FORM_EXTERNAL',
  EMPLOYEE_SELECTION = 'EMPLOYEE_SELECTION',
  EXTERNAL_LANDING_PAGE = 'EXTERNAL_LANDING_PAGE',
  NPS = 'NPS',
  GOODBYE = 'GOODBYE',
  JUMP = 'JUMP',
  SKIPPABLE = 'SKIPPABLE',
  LANGUAGE_CONFIG = 'LANGUAGE_CONFIG' // not an actual step type
}

export interface ApiStep<T extends StepType> extends BaseStep {
  type: StepType; // You can make this more specific or use enums
  api: ApiConfig<T>;
}

export interface BaseStep {
  step: number;
  step_id: number;
  type: StepType;
  messages: StepMessage[];
  input_content: StepContent[];
  actions: StepAction[];
}

export type StepAction = BaseStepAction | OnlineReviewStepAction;

export interface BaseStepAction {
  text: { [lang: string]: string };
  icon: string;
  width?: number;
  button?: { [key: string]: string };
  is_visible?: boolean;
  redirect_timer?: number | string;
  action: {
    jump: number;
    link?: { [key: string]: string };
    redirect?: { [key: string]: string };
    platform?: string;
  };
  condition_value: string | number;
}

export interface StepContent {
  type: string;
  control: string;
  text: string;
}

export interface StepMessage {
  message: { [lang: string]: string };
}
